import { __decorate } from "tslib";
import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
import { ajax } from '@blade/common';
let ImageEditor = class ImageEditor extends VuexModule {
    async getImage() {
        try {
            const res = await ajax.request({
                method: 'GET',
                url: '/api/task-management/api/v1/map',
                // data: data,
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    async updateImage(data) {
        try {
            const res = await ajax.request({
                method: 'PUT',
                url: '/api/task-management/api/v1/map',
                data: { image: data },
            });
            return res.data.data;
        }
        catch (e) {
            throw e;
        }
    }
    updateUrl(payload) { }
};
__decorate([
    Action({ rawError: true })
], ImageEditor.prototype, "getImage", null);
__decorate([
    Action({ rawError: true })
], ImageEditor.prototype, "updateImage", null);
__decorate([
    Mutation
], ImageEditor.prototype, "updateUrl", null);
ImageEditor = __decorate([
    Module({ dynamic: true, store, name: 'senseXplorer/imageEditor' })
], ImageEditor);
export const ImageEditorModule = getModule(ImageEditor);
